// TODO: Move this into ResponsesPage
import * as Immutable from "immutable";
import { Response } from "resourceModels";
import recordMerger from "services/record-merger";

/**
* Returns index of response in list
* @param {Immutable.List} list - response list
* @param {String} id - response id to search for
* @returns {Number}
*/
function getResponseIndex(list, id) {
  return list.findIndex(listItem => listItem.id === id);
}

export const ResponseSideBarRecord = Immutable.Record({
  /** @memberof ResponseRecord# */
  id: null,

  automaticQuickReplies: false,
  buttonLabel: Immutable.Map({}), // Multilingual clarification
  clarifications: true,
  clientId: null,
  created: null,

  /** @memberof ResponseRecord# */
  handle: "",

  /** @memberof ResponseRecord# */
  hasButtonLabel: true,

  description: "",
  descriptiveString: "",
  messages: Immutable.Map({}),

  /** @memberof ResponseRecord# */
  options: Immutable.Map({}),

  rating: null,
  reserved: false,
  tags: Immutable.List([]),
  updated: null,
  saved: true,
  new: false,
  isDirty: false,
  isValid: true,
  live: true,

  reviewable: false,

  /** @memberof ResponseRecord# */
  hasTraining: true,

  canAddMessages: true,

  /** @memberof ResponseRecord# */
  hasQuickReply: true,

  /** @memberof ResponseRecord# */
  reservedResponseType: null
});

// This is the only way to define getters for Immutable.Record
// TODO MEAS-221: This will be moved to `ResourceModels/Response.js`
//  after responses reducer is refactored
Object.defineProperties(ResponseSideBarRecord.prototype, {
  // Get these getters from `Response`
  hasNewLabel: Object.getOwnPropertyDescriptor(Response.prototype, "hasNewLabel"),
  languages: Object.getOwnPropertyDescriptor(Response.prototype, "languages")
});

/**
 *
 * @param {Object} responseObject
 * @param {Object} metaFields
 */
export function createRecordFromResponse(
  responseObject,
  metaFields = {}
) {
  let newResponse = new ResponseSideBarRecord(
    Immutable.fromJS({
      ...recordMerger(responseObject, new ResponseSideBarRecord()),
      reservedResponseType: responseObject._type
    })
  );
  newResponse = newResponse.merge(metaFields);

  return newResponse;
}

let newResponse;
let prevState;

let lastSavedResponses;
let lastSavedResponseIndex;

export const responsesSideBar = (state = Immutable.List([]), action) => {
  let nextState = state;
  let responseIndex;

  switch (action.type) {
    case "GET_RESPONSES_SHALLOW_SUCCESS": {
      prevState = state;

      const returnedResponses = action.response.data.responses;
      nextState = nextState.filter(response => response.new);
      returnedResponses.forEach((response, index) => {
        newResponse = createRecordFromResponse(response, {
          isDirty: !prevState.isEmpty() && prevState.getIn([index, "isDirty"]),
          isValid: prevState.getIn([index, "isValid"]),
          live: response.live
        });
        nextState = nextState.push(newResponse);
      });

      lastSavedResponses = nextState;

      return nextState;
    }

    case "CREATE_RESPONSE_SUCCESS":
      newResponse = createRecordFromResponse(
        action.response.data.response,
        state.find(response => response.id === action.responseId)
      );
      // Set descriptiveString because the response doesn't have it
      // this should likely be a backend feature and this line should be deprecated
      newResponse = newResponse.set("descriptiveString", action.response.data.response.description);

      responseIndex = getResponseIndex(state, newResponse.id);
      lastSavedResponseIndex = getResponseIndex(
        lastSavedResponses,
        newResponse.id
      );

      nextState = nextState.unshift(newResponse);
      lastSavedResponses = lastSavedResponses.unshift(newResponse);

      nextState = nextState.filter(response => response.id !== action.oldId);
      lastSavedResponses = lastSavedResponses.filter(
        response => response.id !== action.oldId
      );

      return nextState;

    case "SAVE_RESPONSE_SUCCESS":
      newResponse = createRecordFromResponse(
        action.response.data.response,
        state.find(response => response.id === action.responseId)
      );
      responseIndex = getResponseIndex(state, newResponse.id);
      lastSavedResponseIndex = getResponseIndex(
        lastSavedResponses,
        newResponse.id
      );

      nextState = nextState.mergeIn([responseIndex], newResponse);
      lastSavedResponses = lastSavedResponses.mergeIn(
        [lastSavedResponseIndex],
        newResponse
      );
      prevState = undefined;

      return nextState;

    case "DELETE_RESPONSE_SUCCESS":
      return state.filter(
        response => response.id !== action.response.data.response._id
      );

    case "CREATE_TAG_SUCCESS":
      if (!action.responseRecord.get("new")) {
        responseIndex = getResponseIndex(state, action.responseRecord.get("id"));

        lastSavedResponseIndex = getResponseIndex(
          lastSavedResponses,
          action.responseRecord.get("id")
        );

        nextState = nextState.updateIn([responseIndex, "tags"], arr => arr.push(action.response.data.tag._id));

        return nextState;
      }

      return nextState;

    case "REMOVE_TAG":
      responseIndex = getResponseIndex(state, action.responseId);
      lastSavedResponseIndex = getResponseIndex(
        lastSavedResponses,
        action.responseId
      );

      nextState = nextState.updateIn([responseIndex, "tags"], arr => arr.filter(tagId => tagId !== action.tagId));

      return nextState;

    case "ADD_TAG_TO_RESPONSE":
      responseIndex = getResponseIndex(state, action.responseId);
      lastSavedResponseIndex = getResponseIndex(
        lastSavedResponses,
        action.responseId
      );

      nextState = nextState.updateIn([responseIndex, "tags"], arr => arr.push(action.tagId));

      return nextState;

    default:
      return nextState;
  }
};
